function I(t, e) {
  const n = N(e);
  return "formatToParts" in n ? D(n, t) : p(n, t);
}
const g = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function D(t, e) {
  try {
    const n = t.formatToParts(e), r = [];
    for (let o = 0; o < n.length; o++) {
      const i = g[n[o].type];
      i !== void 0 && (r[i] = parseInt(n[o].value, 10));
    }
    return r;
  } catch (n) {
    if (n instanceof RangeError)
      return [NaN];
    throw n;
  }
}
function p(t, e) {
  const n = t.format(e), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);
  return [
    parseInt(r[3], 10),
    parseInt(r[1], 10),
    parseInt(r[2], 10),
    parseInt(r[4], 10),
    parseInt(r[5], 10),
    parseInt(r[6], 10)
  ];
}
const c = {}, d = new Intl.DateTimeFormat("en-US", {
  hourCycle: "h23",
  timeZone: "America/New_York",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
}).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), y = d === "06/25/2014, 00:00:00" || d === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
function N(t) {
  return c[t] || (c[t] = y ? new Intl.DateTimeFormat("en-US", {
    hourCycle: "h23",
    timeZone: t,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }) : new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: t,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  })), c[t];
}
function h(t, e, n, r, o, i, a) {
  const s = /* @__PURE__ */ new Date(0);
  return s.setUTCFullYear(t, e, n), s.setUTCHours(r, o, i, a), s;
}
const m = 36e5, w = 6e4, u = {
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function M(t, e, n) {
  let r = u.timezoneZ.exec(t);
  if (r)
    return 0;
  let o, i;
  if (r = u.timezoneHH.exec(t), r)
    return o = parseInt(r[1], 10), l(o) ? -(o * m) : NaN;
  if (r = u.timezoneHHMM.exec(t), r) {
    o = parseInt(r[2], 10);
    const a = parseInt(r[3], 10);
    return l(o, a) ? (i = Math.abs(o) * m + a * w, r[1] === "+" ? -i : i) : NaN;
  }
  if (O(t)) {
    e = new Date(e || Date.now());
    const a = C(e), s = f(a, t);
    return -H(e, s, t);
  }
  return NaN;
}
function C(t) {
  return h(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds());
}
function f(t, e) {
  const n = I(t, e), r = h(n[0], n[1] - 1, n[2], n[3] % 24, n[4], n[5], 0).getTime();
  let o = t.getTime();
  const i = o % 1e3;
  return o -= i >= 0 ? i : 1e3 + i, r - o;
}
function H(t, e, n) {
  let o = t.getTime() - e;
  const i = f(new Date(o), n);
  if (e === i)
    return e;
  o -= i - e;
  const a = f(new Date(o), n);
  return i === a ? i : Math.max(i, a);
}
function l(t, e) {
  return -23 <= t && t <= 23 && (e == null || 0 <= e && e <= 59);
}
const T = {};
function O(t) {
  if (T[t])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: t }), T[t] = !0, !0;
  } catch {
    return !1;
  }
}
function x(t, e) {
  return -M(t, e);
}
export {
  x as g
};
